import moment from 'app/modules/datetime';
import lang from 'app/lib/moment/lang/fr';

moment.lang('fr', lang);



// WEBPACK FOOTER //
// ./src/web/js/app/datetime.fr.js